/* eslint-disable global-require */
import getConfig from 'next/config';
import styled from 'styled-components';
import { LayoutProps, PositionProps, SpaceProps, layout, position, space } from 'styled-system';

const { publicRuntimeConfig } = getConfig();
const basePath = publicRuntimeConfig.basePath;

/**
 * Provides images
 */
export const Images: Record<string, string & Partial<ImageResource>> = {
  appleAppStore: `${basePath}/images/app-store/AppStore_Button.svg`,
  appleAppStoreMobile: `${basePath}/images/app-store/AppStore_Button_Mobile.svg`,
  buying: require('assets/images/static-app-screen-in-illustration.png?resize?'),
  'buying-mobile': require('assets/images/buying-illustration-mobile.png?resize'),
  birdy: require('assets/images/birdy.png?resize&size=411'),
  carInsurance: require('assets/images/car-insurance-card.jpg?resize'),
  'claims-approved': require('assets/images/claims-approved.png?resize'),
  'claims-approved-mobile': require('assets/images/claims-approved-illustration-mobile.png?resize'),
  doggy: require('assets/images/doggy.png?resize'),
  helloPeter: require('assets/images/hello-peter.png?resize'),
  switch: require('assets/images/switch-illustration.png?resize'),
  differenceBabyBox: require('assets/images/difference-baby-box.jpg?resize&size=300'),
  differenceChoc: require('assets/images/difference-choc.jpg?resize&size=300'),
  differenceJam: require('assets/images/difference-jam.jpg?resize&size=300'),
  differenceKolisiFoundation: require('assets/images/difference-kolisi-foundation.jpg?resize&size=300'),
  differenceSurfpop: require('assets/images/difference-surfpop.jpg?resize&size=300'),
  differenceTears: require('assets/images/difference-tears.jpg?resize&size=300'),
  differenceBeachCoop: require('assets/images/difference-the-beach-co-op.jpg?resize&size=300'),
  givebackChristelHouse: require('assets/images/giveback-christel-house.jpg?resize&size=300'),
  givebackCotlands: require('assets/images/giveback-cotlands.jpg?resize&size=300'),
  givebackDoorOfHope: require('assets/images/giveback-door-of-hope.jpg?resize&size=300'),
  givebackOscarsArc: require('assets/images/giveback-oscars-arc.jpg?resize&size=300'),
  givebackTheGreenpopFoundation: require('assets/images/giveback-the-greenpop-foundation.jpg?resize&size=300'),
  givebackLivingLegends: require('assets/images/giveback-living-legends.jpg?resize&size=300'),
  givebackJoziTrails: require('assets/images/giveback-jozi-trails.jpg?resize&size=300'),
  givebackAmoyo: require('assets/images/giveback-amoyo.jpg?resize&size=300'),
  givebackUTurn: require('assets/images/giveback-u-turn.jpg?resize&size=300'),
  givebackNourishEcoVillage: require('assets/images/giveback-nourish-eco-village.jpg?resize&size=300'),
  givebackLifeChoicesAcademy: require('assets/images/giveback-life-choices.jpg?resize&size=300'),
  givebackLIVVillageLanseria: require('assets/images/giveback-liv-village-lanseria.jpg?resize&size=300'),
  givebackGoodMorningAngels: require('assets/images/giveback-good-morning-angels.jpg?resize&size=300'),
  givebackMobileSplash: require('assets/images/giveback-mobile-splash.png?resize'),
  givebackPeople: require('assets/images/giveback-people.png?resize'),
  givebackSplash: require('assets/images/giveback-splash.png?resize&size=1200'),
  googlePlayStore: `${basePath}/images/app-store/GooglePlay_Button.svg`,
  googlePlayStoreMobile: `${basePath}/images/app-store/GooglePlay_Button_Mobile.svg`,
  huaweiAppGallery: `${basePath}/images/app-store/HuaweiAppGallery_Button.svg`,
  huaweiAppGalleryMobile: `${basePath}/images/app-store/HuaweiAppGallery_Button_Mobile.svg`,
  dots: require('assets/images/dots.png?resize'),
  appOnTablet: require('assets/images/app-on-phone-tablet.png?resize&size=500'),
  appLeft: require('assets/images/app-on-phone-left.png?resize&size=500'),
  appRight: require('assets/images/app-on-phone-right.png?resize&size=500'),
  stuff: require('assets/images/cover-all-your-stuffx1.png?resize'),
  individualThings: require('assets/images/cover-your-individual-thingsx1.png?resize'),
  coverYourCar: require('assets/images/cover-your-car.png?resize=600'),
  publications: require('assets/images/publications.png?resize&sizes[]=412,sizes[]=824,sizes[]=1648'),
  hero: `${basePath}/images/Naked_Hero_Home.svg`,
  heroMobile: `${basePath}/images/Naked_Hero_Home_Mobile.svg`,
  appOfTheYear: require('assets/images/app-of-the-year.png?resize'),
  carHeroLeft: `${basePath}/images/Naked_Hero_Car_Left.svg`,
  carHeroRight: `${basePath}/images/Naked_Hero_Car_Right.svg`,
  carHeroMobile: `${basePath}/images/Naked_Hero_Car_Mobile.svg`,
  contentsHeroLeft: `${basePath}/images/Naked_Hero_Contents_Left.svg`,
  contentsHeroRight: `${basePath}/images/Naked_Hero_Contents_Right.svg`,
  contentsHeroMobile: `${basePath}/images/Naked_Hero_Contents_Mobile.svg`,
  sharedImage: require('assets/images/online-insurance-card.jpg?resize&size=1200'),
  careersTeamNakedImage: require('assets/images/naked-careers-team.jpg?resize&size=1200'),
  stepOne: require('assets/images/screenshots-app-step1.png?resize&size=400'),
  stepTwo: require('assets/images/customise-your-insurance-quote.png?resize&size=400'),
  stepThree: require('assets/images/naked-insurance-instant-cover.png?resize&size=400'),
  stepTwoCar: require('assets/images/screenshots-app-step2-car.png?resize&size=400'),
  stepThreeCar: require('assets/images/screenshots-app-step3-car.png?resize&size=400'),
  stepTwoContents: require('assets/images/screenshots-app-step2-contents.png?resize&size=400'),
  stepThreeContents: require('assets/images/screenshots-app-step3-contents.png?resize&size=400'),
  stepTwoBuilding: require('assets/images/screenshots-app-step2-building.png?resize&size=400'),
  stepThreeBuilding: require('assets/images/screenshots-app-step3-building.png?resize&size=400'),
  stepOnePhone: require('assets/images/screenshots-phone-1.png?resize&size=400'),
  stepTwoPhone: require('assets/images/screenshots-phone-2.png?resize&size=400'),
  stepThreePhone: require('assets/images/screenshots-phone-3.png?resize&size=400'),
  squiggleMobile: require('assets/images/squiggle-bg-mobile.jpg?resize&size=400'),
  squiggle: require('assets/images/squiggle-bg.jpg?resize&size=1800'),
  coolestThingAboutNaked: require('assets/images/coolest-thing-working-at-naked.png'),
  whyDoesNakedExist: require('assets/images/why-does-naked-exist.png'),
  qualitiesToWorkAtNaked: require('assets/images/qualities-to-work-at-naked.png'),
  whatElse: require('assets/images/what-else-Naked.png?resize'),
  staticAppScreen: require('assets/images/static-app-screen.png?resize'),
  coverPause: require('assets/images/coverpause.png?resize'),
  damageToOthers: require('assets/images/damage-to-others.png?resize'),
  claiming: require('assets/images/claiming.png?resize'),
  notFoundRight: require('assets/images/404-right.png?resize&size=1200'),
  notFoundLeft: require('assets/images/404-left.png?resize&size=800'),
  notFoundMobile: require('assets/images/404-mobile.png?resize&size=300'),
  notFoundMobileTop: require('assets/images/404-mobile-top.png?resize&size=300'),
  careersHeroDesktop: require('assets/images/careers-hero-desktop.png?resize&size=1200'),
  careersHeroMobile: require('assets/images/careers-hero-mobile.png'),
  faq: require('assets/images/faq.png?resize'),
  buildingHeroLeft: `${basePath}/images/Naked_Hero_Building_Left.svg`,
  buildingHeroRight: `${basePath}/images/Naked_Hero_Building_Right.svg`,
  buildingHeroMobile: `${basePath}/images/Naked_Hero_Building_Mobile.svg`,
  itemsHeroLeft: `${basePath}/images/Naked_Hero_Single_Left.svg`,
  itemsHeroRight: `${basePath}/images/Naked_Hero_Single_Right.svg`,
  itemsHeroMobile: `${basePath}/images/Naked_Hero_Single_Mobile.svg`,
  phoneWelcome: require('assets/images/phone-welcome.png?resize'),
  phoneWelcomeFull: require('assets/images/thank-you-mockup.png?resize'),
  rose: require('assets/images/rose.jpg?resize&size=400'),
  encyclopaediaLanding: `${basePath}/images/encyclopaedia-landing.svg`,
  underwrittenByHollard: `${basePath}/images/underwritten-by-hollard.svg`,
  encyclopaediaBackButton: `${basePath}/images/encyclopaedia-back-button.svg`,
  phoneDropDamage: `${basePath}/images/phone-drop-damage.svg`,
  phoneWaterDamage: `${basePath}/images/phone-water-damage.svg`,
  phoneTheft: `${basePath}/images/phone-theft.svg`,
  phoneHeroMobile: `${basePath}/images/phone-hero-mobile.svg`,
  hellopeter: `${basePath}/images/hellopeter.svg`,
  encyclopaediaDescriptionBoxCorner: `${basePath}/images/encyclopaedia-term-detail-box-corner.svg`,
  secureCheckmark: `${basePath}/images/secure-checkout-icon.svg`,
  phoneHeroRight: `${basePath}/images/phone-hero-right.svg`,
  phoneHeroLeft: `${basePath}/images/phone-hero-left.svg`,
  play: `${basePath}/images/play.svg`,
  pause: `${basePath}/images/pause.svg`,
  shadowDots: `${basePath}/images/dots.svg`,
  leftArrow: `${basePath}/images/left-arrow.svg`,
  rightArrow: `${basePath}/images/right-arrow.svg`,
  externalLink: `${basePath}/images/click-away.svg`,
  broom24: `${basePath}/images/broom-24.svg`,
  getGoogle: `${basePath}/images/app-store/get-android.svg`,
  getApple: `${basePath}/images/app-store/get-apple.svg`,
  getHuawei: `${basePath}/images/app-store/get-huawei.svg`,
  hollardFooter: `${basePath}/images/hollard-footer.svg`,
  facebook: `${basePath}/images/social/facebook.svg`,
  instagram: `${basePath}/images/social/instagram.svg`,
  linkedin: `${basePath}/images/social/linkedin.svg`,
  twitter: `${basePath}/images/social/twitter.svg`,
  tiktok: `${basePath}/images/social/tiktok.svg`,
  basket: `${basePath}/images/basket-24.svg`,
  dropDownArrow: `${basePath}/images/arrow-down-medium.svg`,
  envelope: `${basePath}/images/envelope.svg`,
};

export const Image = styled.img<ImageProps>`
  ${space}
  ${layout}
  ${position}
`;

interface ImageProps extends SpaceProps, LayoutProps, PositionProps {}

interface ImageResource {
  /** Location of image */
  src: string;
  /** the source set of the image */
  srcSet?: string;
}
